// Reine Helfer des Schadenlisten-Menüs — DOM-frei, damit Vitest sie prüfen kann.

/** Dokument-Kategorie, unter der die Schadenlisten des Büros liegen. */
export const KATEGORIE_SCHADENLISTE = "Schadenliste";

/**
 * Anzeigename im Menü: aus „1. Schadenliste - Jacobs Holding (JH) ab 2021.xlsm"
 * wird „Jacobs Holding (JH) ab 2021". Die Dateien hießen auf dem Laufwerk alle
 * gleich an — im Menü unter der Überschrift „Schadenlisten" wäre das nur
 * Rauschen. Bleibt nach dem Kürzen nichts übrig, steht der Dateiname da.
 */
export const listenName = (fileName: string): string => {
  const ohneEndung = fileName.replace(/\.(xlsx|xlsm)$/i, "");
  const kurz = ohneEndung
    .replace(/^\s*\d+\.\s*/, "")
    .replace(/^Schadenliste\s*[-–—:]?\s*/i, "")
    .trim();
  return kurz || ohneEndung;
};

/** Alphabetisch nach Anzeigename, deutsche Sortierung (gewoge neben Generali). */
export const sortiereListen = <T extends { fileName: string }>(listen: T[]): T[] =>
  [...listen].sort((a, b) =>
    listenName(a.fileName).localeCompare(listenName(b.fileName), "de", { sensitivity: "base" }),
  );
